import { RootState } from '../../app/store';

export const selectError = (state: RootState) => state.error.error;

export default {
  selectError,
};
